import { weekdays } from "../../utils/initialDynamicPricingInputs";

export const dateRangeDefaultValues = {
  startDate: null,
  endDate: null,
  daysOfWeek: [...weekdays],
};
